<!--
&lt;!&ndash; Button &ndash;&gt;
<div class="w-max py-2 ml-2 cursor-pointer" [matMenuTriggerFor]="userActions">
    <div class="flex items-center w-full py-2">
        <img *ngIf="!user?.photo" class="h-8 w-auto" src="/assets/icons/user-icon.svg" alt="">
        <img *ngIf="user?.photo" class="h-8 rounded-full w-auto" [src]="env.node + '/uploads/signed?key=' + user.photo + '&token=' + authService.nodeToken" alt="">
        <div class="hidden md:flex flex-col w-full mx-3 overflow-hidden">
            <div class="w-full font-semibold whitespace-nowrap overflow-ellipsis overflow-hidden leading-normal" [ngClass]="{'text-white': dark, 'text-gray-600': !dark}">{{user?.name}}</div>
        </div>
        <span class="flex items-center icon ml-2 md:ml-0">
            <mat-icon class="icon-size-3.5" [ngClass]="{'text-white': dark, 'text-blue-500': !dark}" svgIcon="awesome_solid:chevron-down"></mat-icon>
        </span>
    </div>
</div>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="default-menu">
    <button mat-menu-item disabled>
        <span class="flex flex-col leading-none">
            <span class="font-medium">{{user?.name}}</span>
            <span class="mt-1 text-sm text-secondary font-medium">{{user?.occupation?.name}}</span>
        </span>
    </button>
    <mat-divider *ngIf="user?.occupation || user?.condominium_active" class="my-2"></mat-divider>

    <ng-container *ngIf="layoutAdmin">
        <button [routerLink]="'/dashboard'" mat-menu-item>
            <mat-icon class="icon-size-4.5" [svgIcon]="'awesome_solid:building'"></mat-icon>
            <span class="text-sm">Ir para o Cipa Fácil</span>
        </button>
    </ng-container>

    <ng-container *ngIf="!layoutAdmin">
        <button (click)="appLayoutComponent.toggleCondominium()" *ngIf="user?.condominium_active" mat-menu-item>
            <mat-icon class="icon-size-4.5" [svgIcon]="'awesome_solid:building'"></mat-icon>
            <span class="text-sm">Condomínio: <span class="font-medium">{{user?.condominium_active.condominium.name}}</span></span>
        </button>

        <button *ngIf="hasPermissionAdminView" mat-menu-item [routerLink]="['/admin']">
            <mat-icon class="icon-size-4.5" [svgIcon]="'awesome_solid:user-shield'"></mat-icon>
            <span class="text-sm">Ir para o Painel Administrativo</span>
        </button>
    </ng-container>

    <button *ngIf="user?.occupation && !layoutAdmin" mat-menu-item [routerLink]="['/configuracoes']">
        <mat-icon class="icon-size-4.5" [svgIcon]="'awesome_solid:gear'"></mat-icon>
        <span class="text-sm">Configurações</span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon class="icon-size-4.5" [svgIcon]="'awesome_solid:right-from-bracket'"></mat-icon>
        <span class="text-sm">Sair</span>
    </button>
</mat-menu>

<mat-menu [xPosition]="'before'" class="default-menu" #userCondominium="matMenu">
    <button *ngFor="let condominium of condominiums" (click)="changeCondominium(condominium)" mat-menu-item>
        <mat-icon [svgIcon]="'awesome_solid:building'"></mat-icon>
        <span class="font-medium text-sm">{{condominium.name}}</span>
    </button>
</mat-menu>
-->

<div [matMenuTriggerFor]="userActions" class="flex items-center w-full px-6 py-4 border-t cursor-pointer">
    <!-- Button -->
    <button mat-icon-button>
        <span class="relative">
            <img class="w-9 h-9 rounded-full" *ngIf="user?.photo" [src]="env.node + '/uploads/signed?key=' + user.photo + '&token=' + authService.nodeToken">
            <mat-icon class="icon-size-5" *ngIf="!user?.photo" [svgIcon]="'awesome_light:circle-user'"></mat-icon>
        </span>
    </button>

    <div class="flex flex-col w-full ml-2 overflow-hidden">
        <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden leading-normal text-current opacity-80" [ngClass]="{'text-white': layoutAdmin}">
            {{user.name}}
        </div>
        <div class="w-full mt-0.5 whitespace-nowrap text-sm text-ellipsis overflow-hidden leading-normal text-current opacity-50" [ngClass]="{'text-white': layoutAdmin}">
            {{user.email}}
        </div>
    </div>

    <mat-icon class="icon-size-4 ml-2" [ngClass]="{'text-white': !isCondominiumPage, 'text-primary': isCondominiumPage}" [svgIcon]="'awesome_solid:chevron-down'"></mat-icon>
</div>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Logado como</span>
            <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
        </span>
    </button>
    <ng-container *ngIf="layoutAdmin">
        <mat-divider class="my-2"></mat-divider>
        <button [routerLink]="'/dashboard'" mat-menu-item>
            <mat-icon class="icon-size-4.5 text-gray-800" [svgIcon]="'awesome_solid:building'"></mat-icon>
            <span class="text-sm">Ir para o Cipa Fácil</span>
        </button>
    </ng-container>
    <ng-container *ngIf="!layoutAdmin">
        <mat-divider class="my-2"></mat-divider>
        <button *ngIf="hasPermissionAdminView" mat-menu-item [routerLink]="['/admin']">
            <mat-icon class="icon-size-4.5 text-gray-800" [svgIcon]="'awesome_solid:user-shield'"></mat-icon>
            <span class="text-sm">Ir para o Painel Administrativo</span>
        </button>
    </ng-container>
    <ng-container *ngIf="!isCondominiumPage">
        <mat-divider class="my-2"></mat-divider>
        <button [routerLink]="['/configuracoes']" mat-menu-item>
            <mat-icon class="icon-size-4 text-gray-800" [svgIcon]="'awesome_light:circle-user'"></mat-icon>
            <span>Perfil</span>
        </button>
        <button *ngIf="this.appService.hasPermission('settings_collaborator_view')" [routerLink]="['/configuracoes/users']" mat-menu-item>
            <mat-icon class="icon-size-4 text-gray-800" [svgIcon]="'awesome_solid:user-edit'"></mat-icon>
            <span>Usuários</span>
        </button>
    </ng-container>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon class="icon-size-4 text-gray-800" [svgIcon]="'awesome_solid:sign-out-alt'"></mat-icon>
        <span>Sair</span>
    </button>
</mat-menu>

